import { render, staticRenderFns } from "./PricesSection.vue?vue&type=template&id=2528f128&scoped=true&"
import script from "./PricesSection.vue?vue&type=script&lang=ts&"
export * from "./PricesSection.vue?vue&type=script&lang=ts&"
import style0 from "./PricesSection.vue?vue&type=style&index=0&id=2528f128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2528f128",
  null
  
)

export default component.exports